import React, { useState } from "react";
import { FaPlus, FaCheck } from "react-icons/fa";

const PropertyFeatures = ({ setFormData, formData }) => {
    const amenities = [
        "Maintenance Staff",
        "Water Storage",
        "Security / Fire Alarm",
        "Visitor Parking",
        "Feng Shui / Vaastu Compliant",
        "Park",
        "Intercom Facility",
        "Lift(s)",
    ];

    const features = [
        "High Ceiling Height",
        "False Ceiling Lighting",
        "Piped-gas",
        "Internet/wi-fi connectivity",
        "Power Backup",
        "Air Conditioning",
        "CCTV Surveillance",
        "Rainwater Harvesting",
        "Gymnasium",
    ];

    const societyFeatures = [
        "Water Softening plant",
        "Shoping Centre",
        "Fitness Centre / GYM",
        "Swimming Pool",
        "Club house / Community Center",
        "Security Personal",
    ]

    const additionalFeatures = [
        "Separate entry for servant room",
        "Waste Disposal",
        "No open drainage around",
        "Rain Water Harvesting",
        "Bank Attached Property",
        "Low Density Society",
    ]


    const waterSourceFeatures = [
        "Municipal Corporation",
        "Borewell/Tank",
        "24*7 Water",
    ]


    const overLookingFeatures = [
        "Pool",
        "Park/Garden",
        "Club",
        "Main Road",
        "Others"
    ]

    const otherFeatues = [
        "In a gated society",
        "Corner Property",
        "Pet friendly",
        "Wheelchair friendly",
    ]


    const locationAdvantageFeatures = [
        "Close to Metro Station",
        "Close to School",
        "Close to Railway Station",
        "Close to Airport",
        "Close to Mall",
        "Close to Highway",
    ]


    const [showMore, setShowMore] = useState(false);

    const [selectedItems, setSelectedItems] = useState({
        amenities: [],
        features: [],
        societyFeatures: [],
        additionalFeatures: [],
        waterSourceFeatures: [],
        overLookingFeatures: [],
        otherFeatues: [],
        locationAdvantageFeatures: [],
    });


    const selectedFeatures = formData?.pricingAndOthers?.PropertyFeatures || {
        amenities: [],
        features: [],
        societyFeatures: [],
        additionalFeatures: [],
        waterSourceFeatures: [],
        overLookingFeatures: [],
        otherFeatues: [],
        locationAdvantageFeatures: [],
        type_of_flooring: "",
    };


    // Handle selection toggle
    const toggleSelect = (section, item) => {
        setFormData((prevFormData) => {
            const updatedSection = selectedFeatures[section]?.includes(item)
                ? selectedFeatures[section].filter((i) => i !== item)
                : [...(selectedFeatures[section] || []), item];

            return {
                ...prevFormData,
                pricingAndOthers: {
                    ...prevFormData.pricingAndOthers,
                    PropertyFeatures: {
                        ...selectedFeatures,
                        [section]: updatedSection,
                    },
                },
            };
        });
    };

    const renderItem = (section, item) => {
        const isSelected = selectedFeatures[section]?.includes(item);
        return (
            <div
                key={item}
                onClick={() => toggleSelect(section, item)}
                className={`flex items-center justify-between px-2 py-1 text-sm border rounded-full cursor-pointer 
          ${isSelected
                        ? "bg-blue-100 text-blue-600 border-blue-500"
                        : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                    }`}
            >
                {isSelected ? (
                    <FaCheck className="text-blue-600 mr-2" />
                ) : (
                    <FaPlus className="text-gray-400 mr-2" />
                )}
                <span>{item}</span>
            </div>
        );
    };

    const renderCheckboxItem = (section, item) => {
        const isSelected = selectedFeatures[section]?.includes(item);
        return (
            <div
                key={item}
                onClick={() => toggleSelect(section, item)}
                className={`flex items-center justify-between px-2 py-1 text-sm border rounded-full cursor-pointer 
          ${isSelected
                        ? "bg-blue-100 text-blue-600 border-blue-500"
                        : "bg-gray-100 text-gray-700 hover:bg-gray-200"
                    }`}
            >
                {isSelected ? (
                    <FaCheck className="text-blue-600 mr-2" />
                ) : (
                    <FaPlus className="text-gray-400 mr-2" />
                )}
                <span>{item}</span>
            </div>
        );
    };






    return (
        <div className="">
            {/* Amenities Section */}
            {(formData?.basicDetails?.propertyType !== "Commercial" && formData?.basicDetails?.propertyType !== "agriculture") && <div className="mb-4">
                <h2 className="text-lg font-semibold mb-2">Amenities</h2>
                <div className="flex flex-wrap gap-2">
                    {amenities.map((item) => renderItem("amenities", item))}
                </div>
            </div>}

            {/* Property Features Section */}
            {(formData?.basicDetails?.propertyType !== "Commercial" && formData?.basicDetails?.propertyType !== "agriculture") && <div className="mb-4">
                <h2 className="text-lg font-semibold mb-2">Property Features</h2>
                <div className="flex flex-wrap gap-2">
                    {features.slice(0, showMore ? features.length : 4).map((item) => renderItem("features", item))}
                </div>
                {!showMore && (
                    <button
                        type="button"
                        className="mt-2 text-blue-600 text-sm hover:underline"
                        onClick={() => setShowMore(true)}
                    >
                        7 more
                    </button>
                )}
                {showMore && (
                    <button
                        type="button"
                        className="mt-2 text-blue-600 text-sm hover:underline"
                        onClick={() => setShowMore(false)}
                    >
                        Show less
                    </button>
                )}
            </div>}

            {/* Socity/Building feature Section */}
            {(formData?.basicDetails?.propertyType !== "Commercial" && formData?.basicDetails?.propertyType !== "agriculture") && <div className="mb-4">
                <h2 className="text-lg font-semibold mb-4">Socity/Building feature</h2>
                <div className="flex flex-wrap gap-2">
                    {societyFeatures.slice(0, showMore ? societyFeatures.length : 4).map((item) => renderItem("societyFeatures", item))}
                </div>
                {!showMore && (
                    <button
                        type="button"
                        className="mt-2 text-blue-600 text-sm hover:underline"
                        onClick={() => setShowMore(true)}
                    >
                        7 more
                    </button>
                )}
                {showMore && (
                    <button
                        type="button"
                        className="mt-2 text-blue-600 text-sm hover:underline"
                        onClick={() => setShowMore(false)}
                    >
                        Show less
                    </button>
                )}
            </div>}

            {/* Additional  feature Section */}
            {(formData?.basicDetails?.propertyType !== "Commercial" && formData?.basicDetails?.propertyType !== "agriculture") && <div className="mb-4">
                <h2 className="text-lg font-semibold mb-2">Additional features</h2>
                <div className="flex flex-wrap gap-2">
                    {additionalFeatures.slice(0, showMore ? additionalFeatures.length : 4).map((item) => renderItem("additionalFeatures", item))}
                </div>
                {!showMore && (
                    <button
                        type="button"
                        className="mt-2 text-blue-600 text-sm hover:underline"
                        onClick={() => setShowMore(true)}
                    >
                        7 more
                    </button>
                )}
                {showMore && (
                    <button
                        type="button"
                        className="mt-2 text-blue-600 text-sm hover:underline"
                        onClick={() => setShowMore(false)}
                    >
                        Show less
                    </button>
                )}
            </div>}

            {/* water Source  feature Section */}
            {(formData?.basicDetails?.propertyType !== "Commercial" && formData?.basicDetails?.propertyType !== "agriculture") && <div className="mb-4">
                <h2 className="text-lg font-semibold mb-2">Water Source</h2>
                <div className="flex flex-wrap gap-2">
                    {waterSourceFeatures.map((item) => renderItem("waterSourceFeatures", item))}
                </div>
            </div>}

            {/* overLooking  feature Section */}
            {(formData?.basicDetails?.propertyType !== "Commercial" && formData?.basicDetails?.propertyType !== "agriculture") && <div className="mb-4">
                <h2 className="text-lg font-semibold mb-2">Overlooking</h2>
                <div className="flex flex-wrap gap-2">
                    {overLookingFeatures.map((item) => renderCheckboxItem("overLookingFeatures", item))}
                </div>
            </div>}


            {/* other Features  feature Section */}
            {(formData?.basicDetails?.propertyType !== "Commercial" && formData?.basicDetails?.propertyType !== "agriculture") && <div className="mb-4">
                <h2 className="text-lg font-semibold mb-2">Other featues</h2>
                <div className="flex flex-wrap gap-2">
                    {otherFeatues.map((item) => renderItem("otherFeatues", item))}
                </div>
            </div>}
            {/* type of flooring  Section */}

            {(formData?.basicDetails?.propertyType !== "Commercial" && formData?.basicDetails?.propertyType !== "agriculture") && (
                <div className="mb-4">
                    <h2 className="text-md font-semibold mb-2">Type of Flooring</h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                        <div>
                            <select
                                name="type_of_flooring"
                                value={formData?.pricingAndOthers?.PropertyFeatures?.type_of_flooring || ""}
                                onChange={(e) =>
                                    setFormData((prevData) => ({
                                        ...prevData,
                                        pricingAndOthers: {
                                            ...prevData.pricingAndOthers,
                                            PropertyFeatures: {
                                                ...prevData.pricingAndOthers.PropertyFeatures,
                                                type_of_flooring: e.target.value,
                                            },
                                        },
                                    }))
                                }
                                className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm p-2"
                            >
                                <option value="" disabled>Select Flooring Type</option>
                                <option value="Marble">Marble</option>
                                <option value="Concrete">Concrete</option>
                                <option value="Polished concrete">Polished concrete</option>
                                <option value="Granite">Granite</option>
                                <option value="Ceramic">Ceramic</option>
                                <option value="Mosaic">Mosaic</option>
                                <option value="Stone">Stone</option>
                                <option value="Cement">Cement</option>
                                <option value="Vinyl">Vinyl</option>
                                <option value="Wood">Wood</option>
                                <option value="Vitrified">Vitrified</option>
                                <option value="Spartex">Spartex</option>
                                <option value="IPSFinish">IPSFinish</option>
                                <option value="Others">Others</option>
                            </select>
                        </div>
                    </div>
                </div>
            )}


            {/* Location advantage  feature Section */}
            <div className="mb-4">
                <h2 className="text-lg font-semibold ">Location Advantages</h2>
                <p className="mb-2 text-sm">Highlight the nearby landmarks*</p>
                <div className="flex flex-wrap gap-2">
                    {locationAdvantageFeatures.map((item) => renderItem("locationAdvantageFeatures", item))}
                </div>
            </div>
        </div>
    );
};

export default PropertyFeatures;
